module.exports = __webpack_public_path__ + "motorcyclist.jpg?6d93aa186e8355477371afcdf094a359";